import React from 'react'

const peruRecs = {
    id: 'peru-lima-cusco-recommendations',
    type: 'post',
    countryId: 'peru',
    title: 'Where to Eat, Drink, and Stay in Lima and Cusco',
    longDate: 'June 1, 2018',
    month: 'June',
    date: '1',
    coverImage: 'https://plivesey.github.io/world-of-wander-images/posts/peru/recs/Qorikancha.jpg',
    content: [
        {
            text: (
                <div>When I was planning our trip to Peru, I asked everyone I knew who had been there (plus some strangers in cafes) for recommendations. I got so many awesome ones for restaurants, neighborhoods, bars, and places to stay, I wanted to share the compilation so that anyone else thinking of going can use it!</div>
            )
        },
        {
            text: (
                <div>Lima is known as a food mecca, and a lot of the best restaurants have long waits for reservations. (<a href="https://www.kimkim.com/c/best-places-to-eat-in-lima">Here are a bunch</a> we didn't get to.) Do your research early so you don't miss out!</div>
            )
        },
        {
            header: 'My Top 5'
        },
        {
            text: (
                <div>Caveat: I couldn't get reservations at Maido, Central, or Marcelo Batata, which I'm sure would have made my favorites. But we ate and drank at some amazing spots!
                    <ul>
                        <li><b>Canta Ranita</b>, Lima (Barranco): Brunchy cevicheria hidden in the back of a local market</li>
                        <li><b>Palacio del Inka</b>, Cusco: A splurge hotel with beautiful decor, a perfect location, and daily pisco sour classes in the schmancy lounge</li>
                        <li><b>Juanito's</b>, Cusco (San Blas): Hole-in-the-wall, utterly amazing chicharrones sandwiches. Don't mess with the menu options, just get the real thing.</li>
                        <li><b>Limo</b>, Cusco: Japanese-Peruvian fusion</li>

                        <li><b>Cala</b>, Lima: I made a <a href="http://calarestaurante.com/">reservation</a> one month in advance, and found out when we got there I'd made it for the wrong day. We were early enough in the evening (Americans eat far earlier than Peruvians) that they were still able to seat us on the balcony overlooking the ocean. Great selection of seafood and Italian-esque dishes.</li>
                    </ul>
                </div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/peru/recs/PalacioDelInka.jpg',
            detailText: 'Pisco Sours at Palacio del Inka.'
        },
        {
            header: 'Lima Stay & Do'
        },
        {
            text: (
                <div>
                    <ul>
                        <li>Everyone says to rush through Lima, but take 1-2 days because 1) there are so many awesome places to eat and drink, and you can only fit so many sandwiches and cocktails into your waking hours and 2) travel delays are frequent (happened to us both from US and from Cusco) so if you only allow for 12 hours, that will likely get cut down.</li>
                        <li>Neighborhoods we stayed in: Miraflores (upscale, some of the best restaurants) and Barranco (artsy, close to beach, tons of murals and converted colonial houses.)</li>
                    </ul>
                </div>
            )
        },
        {
            header: 'Lima Eat & Drink'
        },
        {
            text: (
                <div>
                    <ul>

                        <li><b><a hrefh="http://www.maido.pe/en/">Maido</a>:</b> The top ranked restaurant in Peru; Japanese. Need a reservation months ahead.</li>
                        <li><b><a href="https://central.meitre.com/">Central</a>:</b> Second highest ranked restaurant in Peru. Need a reservation months in advance.</li>
                        <li><b><a href="http://calarestaurante.com/">Cala</a>:</b> Safe bet to make a reservation</li>
                        <li><b><a href="http://www.restaurantepuntasal.com/">Punta Sal Miraflores</a>:</b> Cevicheria</li>
                        <li><b>La Rosa Nautica</b></li>
                        <li><b><a href="http://huaringas.com/">Las Huaringas</a></b></li>
                        <li><b><a href="http://www.lamarcebicheria.com/lima/">La Mar</a>:</b> Cevicheria</li>
                        <li><b>Colonial house restaurants</b> and bars in the Barranco neighborhood, including Ayahuasca, Cafe Victoria, DaDA</li>
                        <li><b>Canta Ranita:</b> Brunchy cevicheria hidden in the back of a local market in Barranco</li>
                        <li><b><a href="http://www.picanteriasdelperu.com">La Picanteria</a>:</b> Recreates peruvian food from local vendors around the city. I'm told it has a very local feeling.</li>
                        <li><b>Panchita:</b> Delicious sandwiches, from fillet mignon/lomo to chicharrones</li>
                        <li><b>La Conchita:</b> Trendy spot for chicharrones; long line when we went by</li>
                        <li><b>Isolina</b></li>
                    </ul>
                </div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/peru/recs/Mural.jpg',
            detailText: "One of the colorful murals in Barranco. I know I had awesome photos of the ceviche at Canta Ranita, but they've mysteriously disappeared."
        },
        {
            header: 'Cusco Stay & Do'
        },
        {
            text: (
                <div>
                    <ul>
                        <li><b>Palacio del Inka:</b> A splurge of a hotel, but totally worth it</li>
                        <li><b>Boleto Turistica del Cusco:</b> One ticket is valid for 10 days and gets you into a ton of historical spots in Cusco and the Sacred Valley. They're 130 soles (~$47) each.</li>
                        <li><b>Museo Historico Regional:</b> Fairly interesting and included in the Boleto Turistico; good to fill extra afternoon time.</li>
                        <li><b>Cusco Cathedral:</b> Gold on everything. A tour guide can point out the paintings where the Peruvians who had to paint in the Catholic Spanish style inserted Peruvian references, like when Jesus's last supper is a guinea pig.</li>
                    </ul>
                </div>
            )
        },
        {
            header: 'Cusco Eat & Drink'
        },
        {
            text: (
                <div>
                    <ul>
                        <li><b>Limo:</b> Japanese-Peruvian fusion</li>
                        <li><b>Cicciolina:</b> Our tapas included guinea pig and llama carpaccio. Fun spot.</li>
                        <li><b>Marcelo Batata:</b> Need a reservation way ahead of time</li>
                        <li><b>Chicha:</b> Need a reservation way ahead of time</li>
                        <li><b>La Bodega 138</b></li>
                        <li><b>Museo del Pisco:</b> Flights of Pisco and good mixed drinks</li>
                        <li><b>Republica del Pisco</b></li>
                        <li><b>Inka Team:</b> Loungey cocktail bar</li>
                        <li><b>Juanito's:</b> Ridiculous chicharrones sandwiches in San Blas</li>
                        <li><b>San Blas restaurants:</b> Artsy expat area with healthy food options including Quinta Eulalia, The Meeting Place cafe, and Granja Heidi</li>
                    </ul>
                </div>
            )
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/peru/recs/CuscoSquare.jpg',
            detailText: 'The main square in Cusco is lined with restaurants.'
        },
        {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/peru/recs/MuseodelPisco.jpg',
            detailText: "Museo del Pisco's wall is a mural depicting the pisco making process."
        },
        {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/peru/recs/Chicharrones.jpg', 'https://plivesey.github.io/world-of-wander-images/posts/peru/recs/MPDrink.jpg'],
            detailText: "Left: A salty, delicious chicharrones sandwich at Juanito's. Right: The 'Machu Picchu,' drink I would wish on no one, at an unnamed restaurant."
        }
    ]
}

export default peruRecs


// WEBPACK FOOTER //
// ./src/Posts/Content/PeruRecs.js